'use strict';

require('./navLeft');

const nav = angular.module('dash.nav', [
  'dash.nav.left',
  'common.utils'
]);

nav.run(['NavStore', function (NavStore) {
  NavStore.init();
}]);

nav.factory('NavActions', require('./NavActions'));
nav.factory('NavStore', require('./NavStore'));


// WEBPACK FOOTER //
// ./src/app/dash/nav/index.js